import { urlFoto } from "@/services/url-foto";

function joinCaminhoFoto(relPath) {
  const base = String(urlFoto.caminhoFoto || "").trim();
  const rel = String(relPath || "").trim().replace(/^\/+/, "");
  if (!rel) return "";
  if (!base) return rel;
  return base.endsWith("/") ? base + rel : `${base}/${rel}`;
}

/**
 * Monta URL final usando VUE_APP_ROOT_STORAGE.
 * - path relativo (ex.: visitante_img/foo.png): concatena com a base do .env.
 * - URL absoluta com /storage/... (Laravel costuma mandar com APP_URL errado, ex. http://localhost):
 *   extrai o caminho após /storage/ e reaplica a base do frontend (ex.: http://127.0.0.1:8000/storage/).
 */
export function absolutizarStorageUrl(path) {
  const p = String(path || "").trim();
  if (!p) return "";
  if (/^https?:\/\//i.test(p)) {
    const m = p.match(/^https?:\/\/[^/?#]+\/storage\/(.+)$/i);
    if (m) {
      return joinCaminhoFoto(m[1]);
    }
    return p;
  }
  return joinCaminhoFoto(p);
}
